import { Tooltip } from '@material-ui/core';

import { useNetwork, useWeb3State } from '../../../../../hooks';
import { CHAIN_ID_TO_TYPE_MAP } from '../../../../../lib';
import styles from '../styles.module.css';
import { truncateAddress } from '../utils';

interface Props {
  isOpen?: boolean;
}

export const DisconnectButton = ({ isOpen }: Props) => {
  const { walletDetails, disconnect } = useWeb3State();
  const { chain } = useNetwork();

  const truncatedAddress = truncateAddress(walletDetails.address ?? '');

  const buttonCn = isOpen ? styles.networkRow : styles.closedNetworkRow;
  const networkCn = chain?.unsupported
    ? styles.wrongNetworkName
    : styles.networkName;

  const chainName = chain?.unsupported
    ? 'WRONG'
    : CHAIN_ID_TO_TYPE_MAP[chain?.id] ?? 'WRONG';

  return (
    <Tooltip title="Click to disconnect wallet" placement="top" arrow>
      <button className={buttonCn} onClick={disconnect}>
        <div className={networkCn}>{chainName}</div>
        <div className={styles.walletAddress}>{truncatedAddress}</div>
      </button>
    </Tooltip>
  );
};
